module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/id/3/5-f75d53460715c66a6adafa35f8c945b0.jpg";